import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';

interface ResourceWeekAvailability {
  id?: string;
  resourceId: string;
  dayOfWeek: number;
  startTime: string;
  endTime: string;
}

@Component({
  selector: 'app-resource-availability-dialog',
  templateUrl: './resource-availability-dialog.component.html',
  styleUrls: ['./resource-availability-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class ResourceAvailabilityDialogComponent implements OnInit {
  isValid = true;
  validationMessage = '';
  
  constructor(
    public dialogRef: MatDialogRef<ResourceAvailabilityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      id?: string;
      resourceId: string;
      dayOfWeek: number;
      startTime: string;
      endTime: string;
      daysOfWeek: { value: number; name: string }[];
      availabilities: ResourceWeekAvailability[];
    },
    private snackBar: MatSnackBar
  ) {}
  
  ngOnInit() {
    this.validateTimes();
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }
  
  validateTimes(): void {
    // Reset validation
    this.isValid = true;
    this.validationMessage = '';
    
    // Check if start time is before end time
    if (this.data.startTime >= this.data.endTime) {
      this.isValid = false;
      this.validationMessage = 'Start time must be before end time';
      return;
    }
    
    // Check for overlaps with existing availabilities for the same day
    const sameDay = this.data.availabilities.filter(a => a.dayOfWeek === this.data.dayOfWeek);
    
    for (const slot of sameDay) {
      // Check if new slot overlaps with existing slot
      if (
        (this.data.startTime >= slot.startTime && this.data.startTime < slot.endTime) ||
        (this.data.endTime > slot.startTime && this.data.endTime <= slot.endTime) ||
        (this.data.startTime <= slot.startTime && this.data.endTime >= slot.endTime)
      ) {
        this.isValid = false;
        this.validationMessage = 'Time slot overlaps with an existing availability';
        return;
      }
    }
  }
  
  onSubmit(): void {
    this.validateTimes();
    
    if (!this.isValid) {
      this.snackBar.open(this.validationMessage, 'Close', {
        duration: 3000,
      });
      return;
    }
    
    this.dialogRef.close({
      id: this.data.id,
      resourceId: this.data.resourceId,
      dayOfWeek: this.data.dayOfWeek,
      startTime: this.data.startTime,
      endTime: this.data.endTime
    });
  }
}
